'use strict';

import {Collection} from 'backbone';
import SingleBuyingOptionsRegionModel from './SingleBuyingOptionsRegionModel';
import SingleBuyingOptionCollection from './SingleBuyingOptionCollection';

export default class SingleBuyingOptionsRegionCollection extends Collection {
  get model() {
    return SingleBuyingOptionsRegionModel;
  }

  /**
   * Get all regions buying options.
   *
   * @returns {SingleBuyingOptionCollection}
   */
  getBuyingOptions() {
    let buyingOptions = this.reduce((options, region) => options.concat(region.get('buyingOptions').models), []);
    return new SingleBuyingOptionCollection(buyingOptions);
  }

  /**
   * Get just the addToCartOptions for all regions.
   *
   * @returns {SingleBuyingOptionCollection|null}
   */
  getAddToCartOptions() {
    let buyingOptions = this.reduce((options, region) => {
      return options.concat(region.get('buyingOptions').where({ type: 'AddToCart' }));
    }, []);

    return new SingleBuyingOptionCollection(buyingOptions);
  }

  /**
   * Get just the addToCartOptions for the given region.
   *
   * @param {string} region
   * @returns {SingleBuyingOptionCollection|null}
   */
  getAddToCartOptionsForRegion(region) {
    return this.get(region).get('buyingOptions').getAddToCartOptions();
  }

  /**
   * Get just the addToCartOptions for the all region.
   *
   * @param {string} region
   * @returns {SingleBuyingOptionCollection|null}
   */
  getAddToCartOptionsForAllRegion() {
    return this.getBuyingOptions().getAddToCartOptions();
  }
}



// WEBPACK FOOTER //
// ./assets/components/SingleBuyingOptions/SingleBuyingOptionsRegionCollection.js